"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.error = error;
exports.log = log;
exports.trace = trace;
exports.warn = warn;
/* eslint-disable no-console */

function log(...args) {
  console.log(...args);
}
function warn(...args) {
  console.warn(...args);
}
function error(...args) {
  console.error(...args);
}
function trace(...args) {
  console.trace(...args);
}